import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getIpeUiLocale } from './storage';
import zhCNCommon from './locales/zh-CN/common.json';
import zhCNErrors from './locales/zh-CN/errors.json';
import zhCNWorkbench from './locales/zh-CN/workbench.json';
import zhCNLogin from './locales/zh-CN/login.json';
import enCommon from './locales/en/common.json';
import enErrors from './locales/en/errors.json';
import enWorkbench from './locales/en/workbench.json';
import enLogin from './locales/en/login.json';
import ptBRCommon from './locales/pt-BR/common.json';
import ptBRErrors from './locales/pt-BR/errors.json';
import ptBRWorkbench from './locales/pt-BR/workbench.json';
import ptBRLogin from './locales/pt-BR/login.json';
import esCommon from './locales/es/common.json';
import esErrors from './locales/es/errors.json';
import esWorkbench from './locales/es/workbench.json';
import esLogin from './locales/es/login.json';
import deCommon from './locales/de/common.json';
import deErrors from './locales/de/errors.json';
import deWorkbench from './locales/de/workbench.json';
import deLogin from './locales/de/login.json';
import frCommon from './locales/fr/common.json';
import frErrors from './locales/fr/errors.json';
import frWorkbench from './locales/fr/workbench.json';
import frLogin from './locales/fr/login.json';
import itCommon from './locales/it/common.json';
import itErrors from './locales/it/errors.json';
import itWorkbench from './locales/it/workbench.json';
import itLogin from './locales/it/login.json';
import jaCommon from './locales/ja/common.json';
import jaErrors from './locales/ja/errors.json';
import jaWorkbench from './locales/ja/workbench.json';
import jaLogin from './locales/ja/login.json';
import koCommon from './locales/ko/common.json';
import koErrors from './locales/ko/errors.json';
import koWorkbench from './locales/ko/workbench.json';
import koLogin from './locales/ko/login.json';
import thCommon from './locales/th/common.json';
import thErrors from './locales/th/errors.json';
import thWorkbench from './locales/th/workbench.json';
import thLogin from './locales/th/login.json';
import viCommon from './locales/vi/common.json';
import viErrors from './locales/vi/errors.json';
import viWorkbench from './locales/vi/workbench.json';
import viLogin from './locales/vi/login.json';
import idCommon from './locales/id/common.json';
import idErrors from './locales/id/errors.json';
import idWorkbench from './locales/id/workbench.json';
import idLogin from './locales/id/login.json';

const resources = {
  'zh-CN': { common: zhCNCommon, errors: zhCNErrors, workbench: zhCNWorkbench, login: zhCNLogin },
  en: { common: enCommon, errors: enErrors, workbench: enWorkbench, login: enLogin },
  'pt-BR': { common: ptBRCommon, errors: ptBRErrors, workbench: ptBRWorkbench, login: ptBRLogin },
  es: { common: esCommon, errors: esErrors, workbench: esWorkbench, login: esLogin },
  de: { common: deCommon, errors: deErrors, workbench: deWorkbench, login: deLogin },
  fr: { common: frCommon, errors: frErrors, workbench: frWorkbench, login: frLogin },
  it: { common: itCommon, errors: itErrors, workbench: itWorkbench, login: itLogin },
  ja: { common: jaCommon, errors: jaErrors, workbench: jaWorkbench, login: jaLogin },
  ko: { common: koCommon, errors: koErrors, workbench: koWorkbench, login: koLogin },
  th: { common: thCommon, errors: thErrors, workbench: thWorkbench, login: thLogin },
  vi: { common: viCommon, errors: viErrors, workbench: viWorkbench, login: viLogin },
  id: { common: idCommon, errors: idErrors, workbench: idWorkbench, login: idLogin },
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: getIpeUiLocale(),
    fallbackLng: 'zh-CN',
    defaultNS: 'common',
    ns: ['common', 'errors', 'workbench', 'login'],
    interpolation: { escapeValue: false },
    returnNull: false,
    initImmediate: false,
    react: { useSuspense: false },
  });
}

export default i18n;
